<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog modal-xl  modal-dialog-scrollable">
      <form @submit.prevent="submitForm(false)" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('mail.transfer_message') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="loadForm">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <div class="modal-body">
            
            <div class="row align-items-center">
              <div class="col-12 col-md-2 col-lg-2">
                <h4>{{$t('mail.a')}} <span class="text-danger">*</span></h4>
              </div>
              <div class="col-12 col-md-8 col-lg-8">
                <TagInput
                  containerClass="form-group mb-5"
                  type="email"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  v-model="formDataTransfer.to"
                  :parent-id="'#'+id"
                  :name="`${id}-to`"
                  :helper-text="$t('invoice.help_mail_tag')"
                  :existingTags="contactSuggestions"
                />
              </div>

              <div class="col-12 col-md-1 col-lg-1" v-if="!showTransferCc">
                <div class="d-flex align-items-center">
                  <i class="fa fa-plus-circle fs-4 me-3" @click="showTransferCc = !showTransferCc" style="color: #303D4E;"></i>
                  <h5 class="mt-1">{{$t('mail.cc')}}</h5>
                </div>
              </div>

              <div class="col-12 col-md-1 col-lg-1" v-if="!showTransferCci">
                <div class="d-flex align-items-center">
                  <i class="fa fa-plus-circle fs-4 me-3" @click="showTransferCci = !showTransferCci" style="color: #303D4E;"></i>
                  <h5 class="mt-1">CCi</h5>
                </div>
              </div>
            </div>

            <div class="row align-items-center" v-if="showTransferCc">
              <div class="col-12 col-md-2 col-lg-2">
                  <h4>{{$t('mail.cc')}} <i class="fa fa-minus-circle fs-4 ms-3" @click="showTransferCc = !showTransferCc" style="color: #303D4E;"></i></h4>
              </div>
              <div class="col-12 col-md-10 col-lg-10">
                <TagInput
                  containerClass="form-group mb-5"
                  type="email"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  v-model="formDataTransfer.cc"
                  :parent-id="'#'+id"
                  :name="`${id}-cc`"
                  :helper-text="$t('invoice.help_mail_tag')"
                />
              </div>
            </div>

            <div class="row align-items-center" v-if="showTransferCci">
              <div class="col-12 col-md-2 col-lg-2">
                  <h4>CCi <i class="fa fa-minus-circle fs-4 ms-3" @click="showTransferCci = !showTransferCci" style="color: #303D4E;"></i></h4>
              </div>
              <div class="col-12 col-md-10 col-lg-10">
                <TagInput
                  containerClass="form-group mb-5"
                  type="email"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  v-model="formDataTransfer.bcc"
                  :parent-id="'#'+id"
                  :name="`${id}-bcc`"
                  :helper-text="$t('invoice.help_mail_tag')"
                />
              </div>
            </div>

            <div class="row align-items-center border-bottom">
                <div class="col-12 col-md-2 col-lg-2">
                    <h4>{{$t('mail.subject')}} <span class="text-danger">*</span></h4>
                </div>
                <div class="col-12 col-md-10 col-lg-10">
                  <Input
                    container-class="form-group mb-5"
                    :name="`subject`+ id"
                    type="text"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    size="lg"
                    v-model="formDataTransfer.subject"
                  />
                </div>
            </div>
            
            <div class="row mt-5">
                <div class="col-12 col-md-8 col-lg-8">
                    <CKEditor
                      :id="'mail-editor-transfer'+id"
                      container-class="h-400px"
                      :content="formDataTransfer.message"
                      @text="getDescription"
                      ref="ckeditor"
                      @ready="onEditorReady"
                    />
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                  <div class="card border_style">
                    <div class="card-header">
                      <div class="d-flex align-items-center">
                        <h2>{{$t('pipelines.attach_files')}}</h2>
                        <span class="badge badge-light-warning fs-2 mb-2 ms-3">{{fileCount}}</span>
                      </div>
                    </div>
                    <div class="card-body p-5">
                      <div style="overflow-y: auto; max-height: 280px !important;">
                        <UploadFile :id="'upload_file3'+id" :size="2" :number="20" v-model="formDataTransfer.newAttachments"/>
                        <FileUploaded :remove="true" @remove="removeFile" :attach-files="attachFiles"/>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <br>
            <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6 mt-15">
              <li class="nav-item">
                  <a class="nav-link active" data-bs-toggle="tab" :href="'#kt_settings'+id">{{ $t("menu.settings") }}</a>
              </li>
              <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" :href="'#kt_signature'+id">{{ $t("menu.signature") }}</a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" :id="'kt_settings'+id" role="tabpanel">
                <div class="d-flex align-items-center gap-4">
                  <div class="form-check me-5 mt-2">
                    <input class="form-check-input" type="checkbox" v-model="formDataTransfer.request_receipt" id="flexCheckDefault"/>
                    <label class="ms-2 form-label fs-6 text-black" for="flexCheckDefault">
                      {{ $t('mail.request_receipt') }}
                    </label>
                  </div>
                  <div class="d-flex align-items-center gap-3 mt-1">
                    <span class="me-2 form-label fs-6 text-black mt-1">{{ $t('mail.priority') }}</span>
                    <Select2
                      :parent-id="`#${id}`"
                      containerClass="col-12"
                      :name="`${id}-transfer_priority`"
                      :multiple="false"
                      selectClass="form-select-sm form-select-solid form-control-sm"
                      :isRequired="false"
                      :placeholderText="$t('mail.priority')"
                      v-model="formDataTransfer.priority"
                    >
                      <option v-for="(priority, index) in transferPriorities" :key="index" :value="priority.value">
                        {{ priority[locale] }}
                      </option>
                    </Select2>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" :id="'kt_signature'+id" role="tabpanel">
                <div class="d-flex align-items-center gap-3">
                  <span class="me-2 form-label fs-6 text-black">{{ $t('menu.select_signature') }}</span>
                  <Select2
                    :parent-id="`#${id}`"
                    containerClass="col-6"
                    :name="`${id}-signature`"
                    :multiple="false"
                    selectClass="form-select-sm form-select-solid form-control-sm"
                    :isRequired="false"
                    :placeholderText="$t('menu.select_signature')"
                    v-model="transferSelectedSignature"
                    :IsInputGroup="true"
                    icon="bi bi-plus"
                    :clickAddon="openSignatureModal"
                    :clear="true"
                  >
                    <option v-for="(signature, index) in signatures" :key="index" :value="signature.id">
                      {{ signature.name }}
                    </option>
                  </Select2>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer mt-20">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click.prevent.stop="loadForm"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.send" size="7px 30px" :is-loading="isLoadingTransfer"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <SignatureModal :id="'create_signature_modal'+id" @load="loadData" :parent="id"/>
</template>

<script setup>
  import {ref, defineEmits, defineProps, watch, computed, onMounted} from "vue";
  import Input from "@/components/Input.vue";
  import {useStore} from "vuex";
  import Button from "@/components/Button.vue"
  import RequiredText from "@/components/RequiredText.vue";
  import CKEditor from '@/components/CKEditor.vue';
  import UploadFile from "@/components/UploadFile";
  import TagInput from "@/components/TagifyInput.vue";
  import FileUploaded from "@/components/FileUploaded";
  import Select2 from "@/components/Select2";
  import {useLocales} from "@/composables/locales";
  import SignatureModal from "./SignatureModal.vue"

  const store = useStore()
  const {locale} = useLocales()

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      default: {
        to: [],
        cc: [],
        bcc: [],
        subject: '',
        message: '',
        attachments: [],
        email_id: '',
        scheduled_at: '',
        priority: '3 (Normal)',
        request_receipt: false,
        folder: '',
        is_draft: false
      }
    }
  })
  const emits = defineEmits(['load', 'transfer'])

  const isLoadingTransfer = ref(false)
  const showTransferCc = ref(false)
  const showTransferCci = ref(false)
  const transferSelectedSignature = ref('')
  const oldSelectedSignature = ref('')
  const ckeditor = ref(null)

  const formDataTransfer = ref({})
  const attachFiles = ref([])
  const contacts = computed(() => store.getters['mails/getUserContacts'])
  const transferPriorities = computed(() => store.getters['mails/getPriorities'])
  const contactSuggestions = computed(() => {
    return contacts.value
      ?.filter(item => item.email)
      .map(item => {
        return `${item.fullname} <${item.email}>`;
      }) || [];
  });
  const activeSignature = computed(() => store.getters['mails/getActiveSignature'])
  const signatures = computed(() => store.getters['mails/getSignatures'])
  const fileCount = computed(() => formDataTransfer.value.attachments?.length || 0)
  const removeElt = computed(() => {
    return signatures.value?.find(item => item.id === oldSelectedSignature.value);
  }); 
  const isTransferDraft = computed(() => {
    if (ckeditor.value && ckeditor.value.editorInstance) {
      const editor = ckeditor.value.editorInstance
      const data = editor.getData().trim()
      const signatureHtml = `<p style="text-align: right;">${activeSignature.value?.content || ''}</p>`.trim()

      const parser = new DOMParser()
      const docContent = parser.parseFromString(data, 'text/html').body.textContent?.trim()
      const docSignature = parser.parseFromString(signatureHtml, 'text/html').body.textContent?.trim()

      if (docContent && docContent !== '' && docContent !== docSignature) {
        return true
      }

      return false
    }
  })

  watch(() => props.form.attachments, (value) => {
    if(value){
      attachFiles.value = value?.map((item, index) => {
        return {
          name: item.name,
          url: item.url,
          type: item.url?.split('.')[1],
          id: index + 1
        }
      })
    }
  })

  watch(() => props.form, (value) => {
    if(value) {
      if(value.cc.length > 0) {
        showTransferCc.value = true
      }else {
        showTransferCc.value = false
      }
      if(value.bcc.length > 0) {
        showTransferCci.value = true
      }else {
        showTransferCci.value = false
      }

      formDataTransfer.value = JSON.parse(JSON.stringify(value))
    }
  }, { deep: true });

  function getDescription(text) {
    if (formDataTransfer.value.message !== text) {
      formDataTransfer.value.message = text;
    }
  }

  function removeFile(file) {
    attachFiles.value = attachFiles.value.filter(x => x !== file);
  }

  watch(() => activeSignature.value, (value) => {
    if(value) {
      transferSelectedSignature.value = activeSignature.value.id
    }
  });

  watch(() => transferSelectedSignature.value, (newVal, oldVal) => {
    if (newVal !== oldVal) {
      oldSelectedSignature.value = oldVal;
      if (oldSelectedSignature.value && removeElt.value) {
        removeSignature(removeElt.value.content);
      }
      if(newVal){
        changeSignature();
      }
    }
  });

  function changeSignature() {
    if(transferSelectedSignature.value) {
      store.dispatch('mails/selectSignature', transferSelectedSignature.value).then((response) => {
        store.dispatch('mails/loadActiveSignatures').then((res) => {
          insertSignature(activeSignature.value?.content)
          removeEmptyParagraphs()
        })
      })
    }
  }

  function openSignatureModal(){
    closeModal()
    $('#create_signature_modal'+props.id).modal('toggle')
  }

  function onEditorReady(editor) {
    ckeditor.value.editorInstance = editor;
  }

  function insertSignature(variableText) {
    if (!ckeditor.value || !ckeditor.value.editorInstance) return;

    const editor = ckeditor.value.editorInstance;

    const htmlSignature = `\n<p style="text-align: right;">${variableText}</p>`;

    const viewFragment = editor.data.processor.toView(htmlSignature);
    const modelFragment = editor.data.toModel(viewFragment);

    editor.model.change(writer => {
      const root = editor.model.document.getRoot();
      const endPosition = editor.model.createPositionAt(root, 'end');

      const emptyParagraph = writer.createElement('paragraph');
      editor.model.insertContent(emptyParagraph, endPosition);

      const newEndPosition = editor.model.createPositionAt(root, 'end');

      editor.model.insertContent(modelFragment, newEndPosition);

      writer.setSelection(editor.model.createPositionAt(root, 'end'));
    });
  }

  function removeSignature(variableText) {
    if (!ckeditor.value || !ckeditor.value.editorInstance) return;

    const editor = ckeditor.value.editorInstance;
    const model = editor.model;

    const viewFragment = editor.data.processor.toView(variableText);
    const modelFragment = editor.data.toModel(viewFragment);

    model.change(writer => {
      const root = model.document.getRoot();
      const range = model.createRangeIn(root);

      const elementsToRemove = Array.from(modelFragment.getChildren());

      for (const element of elementsToRemove) {
        for (const item of range.getItems()) {
          if (item.is('element') && item.name === element.name) {
            const itemData = item.getChild(0)?.data?.trim();
            const elementData = element.getChild(0)?.data?.trim();

            if (itemData === elementData) {
              writer.remove(item);
              break;
            }
          }
        }
      }
    });
  }

  function clearEditorContent() {
    if (!ckeditor.value || !ckeditor.value.editorInstance) return;

    const editor = ckeditor.value.editorInstance;

    editor.model.change(writer => {
      const root = editor.model.document.getRoot();

      for (const child of Array.from(root.getChildren())) {
        writer.remove(child);
      }

      const emptyParagraph = writer.createElement('paragraph');
      writer.insert(emptyParagraph, root, 'end');
      writer.setSelection(emptyParagraph, 'in');
    });
  }

  function removeEmptyParagraphs() {
    if (!ckeditor.value || !ckeditor.value.editorInstance) return;

    const editor = ckeditor.value.editorInstance;
    const model = editor.model;
    const root = model.document.getRoot();

    model.change(writer => {
      const paragraphs = Array.from(root.getChildren()).filter(item =>
        item.is('element', 'paragraph')
      );

      for (const paragraph of paragraphs) {
        const textContent = Array.from(paragraph.getChildren())
          .map(child => child.data?.trim())
          .join('');

        if (!textContent || textContent === '\u00A0') {
          writer.remove(paragraph);
        }
      }
    });
  }

  function closeModal(){
    $('#'+props.id).modal('hide')
    emits('transfer', false)
    showTransferCc.value = false
    showTransferCci.value = false
  }

  function loadForm() {
    if (isTransferDraft.value && !formDataTransfer.value.is_draft) {
      closeModal()
      submitForm(true)
    }else{
      closeModal()
      resetForm()
      clearEditorContent()
      changeSignature()
    }
    
  }

  function resetForm() {
    formDataTransfer.value.to = []
    formDataTransfer.value.subject = ''
    formDataTransfer.value.message = ''
    formDataTransfer.value.cc = []
    formDataTransfer.value.bcc = []
    formDataTransfer.value.attachments = []
    formDataTransfer.value.newAttachments = []
    formDataTransfer.value.email_id = ''
    formDataTransfer.value.folder = ''
    formDataTransfer.value.is_draft = false
  }

  function formatArray(items){
    let data = []
    items.forEach(item => {
      const emailMatch = item.match(/<([^>]+)>/)
      if (emailMatch) {
        data.push(emailMatch[1])
      }else{
        data.push(item)
      }
    })
    return data
  }

  function submitForm(draft=false) {
    formDataTransfer.value.attachments = attachFiles.value
    if(draft) formDataTransfer.value.is_draft = draft
    isLoadingTransfer.value = true;
    emits('transfer', isLoadingTransfer.value)

    store.dispatch('mails/transferMail',
        {
          ...formDataTransfer.value,
          to: formatArray(formDataTransfer.value.to),
          cc: formatArray(formDataTransfer.value.cc),
          bcc: formatArray(formDataTransfer.value.bcc)
        }).then((res) =>{
      emits('load');
      loadForm()
      if(!draft) window.toastr['success'](i18n.global.t('mail.transfer_successfully'))
    }).finally(() => {
      isLoadingTransfer.value = false;
      emits('transfer', isLoadingTransfer.value)
    })
  }

  function loadData() {
    store.dispatch('mails/loadSignatures')
    store.dispatch('mails/loadActiveSignatures')
  }

  onMounted(() => {
    $('#'+props.id).on('shown.bs.modal', () => {
      attachFiles.value = props.form.attachments.map((item, index) => {
        return {
          name: item.name,
          url: item.url,
          type: item.url?.split('.')[1],
          id: index + 1
        }
      })
    });
    loadData()
    formDataTransfer.value = JSON.parse(JSON.stringify(props.form))
  })
</script>
    
<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }

  .border_style {
    border: 2px solid var(--bs-light)
  }

  .modal-dialog,
.modal-content {
  overflow: visible !important;
}

  .modal-content {
    overflow-x: auto;
  }

  .modal-body {
    min-width: 700px;
  }
</style>